import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import ListControlPanel from './ListControlPanel/ListControlPanel';

class ListHeader extends Component {
  static getDerivedStateFromProps(props, prevState) {
    if (prevState.prevSearchFromProps !== props.search) {
      return { search: props.search, prevSearchFromProps: props.search };
    }
    return null;
  }

  state = {
    search: this.props.search,
    prevSearchFromProps: this.props.search,
  };

  triggerSearch = debounce((search) => {
    this.props.onSearchChange(search);
  }, 800);

  handleSearchChange = (search) => {
    this.setState({ search });
    this.triggerSearch(search);
  };

  render() {
    const {
      onAddButtonClick,
      onLimitChange,
      pagination,
      onPageChange,
      addButtonText,
      withoutSearch,
      withoutAddButton,
      withoutPerPage,
      withoutPagination,
      isLoading,
      buttonComponent,
    } = this.props;

    return (
      <ListControlPanel
        buttonComponent={buttonComponent}
        isLoading={isLoading}
        searchValue={this.state.search}
        onPerPageChange={onLimitChange}
        onAddButtonClick={onAddButtonClick}
        onSearchChange={this.handleSearchChange}
        pagination={pagination}
        onPageChange={onPageChange}
        addButtonText={addButtonText}
        withSearch={!withoutSearch}
        withAddButton={!withoutAddButton}
        withPerPage={!withoutPerPage}
        withPagination={!withoutPagination}
      />
    );
  }
}

export default ListHeader;